export default "/_next/static/images/A1-dccd9b550cb9dfb5a67a2d5c4f7f7f00.png";